import React from "react";
var __jsx = React.createElement;
var OilProductDescription = function OilProductDescription(_ref) {
  var section = _ref.section;
  var title = section.title,
    features = section.content;
  if (!features.length) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "py-5 md:py-8"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-sm md:text-2xl font-bold text-[#1B2035] mb-4 md:mb-6 md:px-0 px-4"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 gap-2 px-4 md:px-0"
  }, features.map(function (feature) {
    return /*#__PURE__*/React.createElement("div", {
      key: feature.id,
      className: "flex flex-col items-center md:justify-center md:gap-2 bg-[#FBFBFB] rounded-lg md:rounded-xl md:border md:border-solid md:border-[#E6E9EF] p-1 md:px-3 md:py-2 w-full md:h-[94px] md:w-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0"
    }, /*#__PURE__*/React.createElement("img", {
      src: feature.icon,
      alt: "",
      className: "w-6 h-6 md:w-10 md:h-10 object-contain"
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] md:text-sm font-medium text-[#1B2035] text-center leading-snug"
    }, feature.title));
  })));
};
export default OilProductDescription;